import "./Divider.scss";

export const Divider = ({ styles }) => (
    <div className="divider" style={styles} />
  );
